/**
 * @typedef {{
 *   highlightImages?: Record<string, string>;
 *   fallbackImage?: string;
 *   inclusionIllustrations?: Record<string, string>;
 * }} TourPresentation
 */

/** @type {Record<string, TourPresentation>} */
export const tourPresentation = {
	P18ZC5: {
		highlightImages: {
			'temperate-rainforest-walk': '/src/lib/assets/highlights/bruny-island-1.jpg',
			'walking-tracks-and-coastal-lookouts': '/src/lib/assets/highlights/walking-tracks.jpg',
			'the-neck-lookout': '/src/lib/assets/highlights/bruny-2.png',
			'wildlife-spotting': '/src/lib/assets/highlights/wildlife.jpg',
			'beaches-lagoons-and-swimming': '/src/lib/assets/highlights/bruny-island-day-tour.jpg',
			'cape-bruny-lighthouse': '/src/lib/assets/highlights/lighthouse.jpg',
			'lunch-and-local-produce': '/src/lib/assets/highlights/oysters.jpg'
		},
		fallbackImage: '/src/lib/assets/highlights/bruny-island-day-tour.jpg'
	},
	P01GQC: {
		highlightImages: {
			'mavista-rainforest': '/src/lib/assets/highlights/bruny-island-1.jpg',
			'short-active-walks-and-at-least-one-1-5-hour-hike':
				'/src/lib/assets/highlights/walking-tracks.jpg',
			'beaches-lagoons-and-swimming': '/src/lib/assets/highlights/hero-carousel-1.jpg',
			'coastal-scenery-and-wildlife': '/src/lib/assets/highlights/bruny-2.png',
			'picnic-lunch-and-the-adventure-bay-shop': '/src/lib/assets/highlights/food.jpg',
			'local-produce-to-finish': '/src/lib/assets/highlights/oysters.jpg'
		},
		fallbackImage: '/src/lib/assets/highlights/bruny-island-day-tour.jpg'
	},
	PJHLE0: {
		highlightImages: {
			'pirates-bay-lookout': '/src/lib/assets/highlights/pirates-bay.png',
			'the-historic-dog-line': '/src/lib/assets/highlights/dog-line.png',
			'tasmanian-chocolate-foundry': '/src/lib/assets/highlights/choc-foundry.jpg',
			'lavender-farm': '/src/lib/assets/highlights/lavender.jpg',
			'port-arthur-historic-site': '/src/lib/assets/highlights/historic-site.jpg',
			'remarkable-cave': '/src/lib/assets/highlights/remarkable.png',
			'blue-lagoon-oysters': '/src/lib/assets/highlights/oysters.png'
		},
		fallbackImage: '/src/lib/assets/highlights/historic-site.jpg'
	},
	PNVP8M: {
		highlightImages: {
			'hobart-city-loop': '/src/lib/assets/highlights/battery-point.jpg',
			'kunanyi-mt-wellington': '/src/lib/assets/highlights/sunset.jpg',
			'salamanca-market-saturdays-only': '/src/lib/assets/highlights/markets.jpg',
			'wicked-cheese': '/src/lib/assets/highlights/beer.jpeg',
			richmond: '/src/lib/assets/highlights/salmon-ponds.jpg',
			'bonorong-wildlife-sanctuary': '/src/lib/assets/highlights/bonorong.png'
		},
		fallbackImage: '/src/lib/assets/highlights/battery-point.jpg'
	},
	PQKW4C: {
		highlightImages: {
			'kunanyi-mt-wellington': '/src/lib/assets/highlights/sunset.jpg',
			richmond: '/src/lib/assets/highlights/salmon-ponds.jpg',
			'hobart-city-loop': '/src/lib/assets/highlights/battery-point.jpg',
			'salamanca-market-saturdays-only': '/src/lib/assets/highlights/markets.jpg'
		},
		fallbackImage: '/src/lib/assets/highlights/battery-point.jpg'
	},
	PQ5CJC: {
		highlightImages: {
			'russell-falls-horseshoe-falls-and-lady-barron-falls':
				'/src/lib/assets/highlights/russell-falls.jpg',
			'ancient-rainforest-and-towering-eucalypts': '/src/lib/assets/highlights/walks.jpg',
			'derwent-valley-tasting-trail': '/src/lib/assets/highlights/derwent.jpg',
			'westerway-raspberry-farm-seasonal': '/src/lib/assets/highlights/raspberries.jpg',
			'grazing-platter': '/src/lib/assets/highlights/tasting-board.jpg'
		},
		fallbackImage: '/src/lib/assets/highlights/russell-falls.jpg'
	},
	PTC0KJ: {
		highlightImages: {
			'huonville-and-the-huon-river': '/src/lib/assets/highlights/scenic.jpg',
			'tahune-airwalk': '/src/lib/assets/highlights/tahune.jpg',
			'hastings-caves': '/src/lib/assets/highlights/hastings-1.jpg',
			'cider-and-apple-pie-finish': '/src/lib/assets/highlights/cider-board.jpg'
		},
		fallbackImage: '/src/lib/assets/highlights/tahune.jpg'
	},
	PCBKLS: {
		highlightImages: {
			'dove-lake': '/src/lib/assets/enhanced/cradle-mountain.jpg',
			'ancient-rainforest-walks': '/src/lib/assets/highlights/walks.jpg'
		},
		fallbackImage: '/src/lib/assets/enhanced/cradle-mountain.jpg'
	},
	PNNK81: {
		highlightImages: {
			'flexible-hiking-options': '/src/lib/assets/highlights/wb-2.jpg',
			'scenic-walk-to-the-wineglass-bay-lookout': '/src/lib/assets/highlights/wb-1.jpg',
			'cape-tourville-lighthouse': '/src/lib/assets/highlights/wineglass-bay.jpg',
			'honeymoon-bay': '/src/lib/assets/highlights/wb-5.jpg',
			'freycinet-marine-farm': '/src/lib/assets/highlights/wb-3.jpg',
			'meal-options': '/src/lib/assets/highlights/wb-6.jpg',
			'ice-cream-to-finish': '/src/lib/assets/highlights/wb-4.jpg'
		},
		fallbackImage: '/src/lib/assets/highlights/wineglass-bay.jpg'
	},
	PHJFAH: {
		highlightImages: {
			'flexible-hiking-options': '/src/lib/assets/highlights/wb-2.jpg',
			'wineglass-bay-lookout': '/src/lib/assets/highlights/wb-1.jpg',
			'cape-tourville': '/src/lib/assets/highlights/wineglass-bay.jpg',
			'honeymoon-bay': '/src/lib/assets/highlights/wb-5.jpg',
			'freycinet-marine-farm': '/src/lib/assets/highlights/wb-3.jpg'
		},
		fallbackImage: '/src/lib/assets/highlights/wineglass-bay.jpg'
	},
	P1VDC1: {
		inclusionIllustrations: {
			'transport-and-entry': '/src/lib/assets/illustrations/transport.png',
			accommodation: '/src/lib/assets/illustrations/resting.png',
			meals: '/src/lib/assets/illustrations/food.png',
			'photography-program': '/src/lib/assets/illustrations/certificate.png'
		}
	}
};

/** @type {Record<string, string>} */
const inclusionCategoryIllustrations = {
	transport: '/src/lib/assets/illustrations/transport.png',
	guides: '/src/lib/assets/illustrations/map.png',
	accommodation: '/src/lib/assets/illustrations/resting.png',
	meals: '/src/lib/assets/illustrations/food.png',
	activities: '/src/lib/assets/illustrations/adventure.png',
	'entry-and-transfers': '/src/lib/assets/illustrations/map.png',
	'photography-program': '/src/lib/assets/illustrations/certificate.png'
};

const genericInclusionIllustration = '/src/lib/assets/illustrations/planning.png';

/**
 * @param {{ productCode: string; sectionKey: string; images?: Array<{ itemUrl?: string; largeSizeUrl?: string }> }} options
 */
export function resolveHighlightVisual(options) {
	const { productCode, sectionKey, images = [] } = options;
	const presentation = tourPresentation[productCode];
	const explicit = presentation?.highlightImages?.[sectionKey];
	if (explicit) return { type: 'local', source: explicit };
	if (presentation?.fallbackImage) return { type: 'local', source: presentation.fallbackImage };

	const galleryImage = images.find((image) => image?.itemUrl || image?.largeSizeUrl);
	if (galleryImage) {
		return {
			type: 'remote',
			source: galleryImage.itemUrl || galleryImage.largeSizeUrl
		};
	}

	return null;
}

/** @param {{ productCode: string; sectionKey: string }} options */
export function resolveInclusionIllustration(options) {
	const { productCode, sectionKey } = options;
	return (
		tourPresentation[productCode]?.inclusionIllustrations?.[sectionKey] ||
		inclusionCategoryIllustrations[sectionKey] ||
		genericInclusionIllustration
	);
}
